<template>
  <div>

    <br/>
    <router-link :to="{ name: 'Grand24Page' }">
      Retour à la page du Grand 24h
    </router-link>

    <div v-html="html"></div>

    <template v-if="loaded === false">
      <h3>Page non trouvée</h3>
    </template>

    <router-link :to="{ name: 'Grand24Page' }">
      Retour à la page du Grand 24h
    </router-link>
    <br/><br/>

  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    name: 'Grand24Single',
    data() {
      return {
        year: this.$route.params.year,
        html: null,
        loaded: null
      };
    },
    async mounted() {
      const data = await fetch(this.path());
      if (!data.ok) {
        this.loaded = false;
      }
      else {
        this.html = await data.text();
      }
    },
    methods: {
      path() {
        if (!_.isNumber(this.year) && _.size(this.year.toString()) !== 4) {
          this.year = 2019;
        }
        return '/pages/grand_24h/' + this.year + '.html';
      }
    }
  };
</script>

<style scoped></style>
